<template>
  <div>
    <el-select @change="changeStatus()"
               v-model="val"
               size="mini">

        <el-option
                v-for="item in formatData.statuses"
                :key="item.id"
                :label="item.title"
                :value="+item.id"
        ></el-option>


    </el-select>
  </div>
</template>

<script>
  export default {
    name: 'StatusScanChanging',
    props:{
      scanIndex: Number,
      scanData: Object,
      formatData: Object
    },
    data () {
      return {
        val: 1
      }
    },
    watch:{
      scanIndex: function (val) {
        this.val = this.scanData.status
      }
    },
    created(){
      this.val = this.scanData.status
    },
    methods:{
      changeStatus(){
        this.$store.dispatch('scans/updateScan', {id:this.scanData.id, status: this.val})
      }
    }
  }
</script>

<style scoped>

</style>
